import LoginDropdown from '../DesktopNav/LoginDropdown'
import Menubar from '../AriaMenu/Menubar'
import React from 'react'
import '../../styles/index.scss'
import '../../styles/navbar/styles.scss'

function DesktopNav () {
  return (
    <nav className='navbar' role='navigation'>
      <Menubar className='navbar__menubar' role='menubar'>
        <li><LoginDropdown /></li>
      </Menubar>
    </nav>
  )
}

export default DesktopNav
